import { render, staticRenderFns } from "./ProductVariants.vue?vue&type=template&id=e241c1ce&scoped=true"
import script from "./ProductVariants.vue?vue&type=script&lang=js"
export * from "./ProductVariants.vue?vue&type=script&lang=js"
import style0 from "./ProductVariants.vue?vue&type=style&index=0&id=e241c1ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e241c1ce",
  null
  
)

export default component.exports